import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';
import Title from '../Title';
import { useTranslation } from 'react-i18next';

const ProdSupport = () => {
  const { t } = useTranslation();
  return (
    <section className='flex flex-col p-6 md:p-12 gap-6 md:gap-12'>
      <Title>
        {t('product_page.product_support.title')}
      </Title>
      <div className='flex flex-col items-center justify-center text-center gap-6'>
        <p className='text-lg lg:text-xl font-light text-primary-blue'>
          {t('product_page.product_support.description')}
        </p>
        <Link to='/contact'>
          <Button>
            {t('product_page.product_support.button')}
          </Button>
        </Link>
      </div>
    </section>
  );
}

export default ProdSupport;